import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#focus", label: "焦点速递" },
  { href: "#live", label: "实时滚动" },
  { href: "#rank", label: "热搜排行" },
  { href: "#depth", label: "深度追踪" },
  { href: "#faq", label: "热点问答" },
  { href: "#about", label: "关于我们" },
];

function pad(n: number) {
  return n.toString().padStart(2, "0");
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const clock = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 报头 */}
      <div className="bg-foreground-950 text-background-50">
        <div className="mx-auto flex max-w-[1440px] items-center justify-between gap-4 px-4 py-3 md:px-6">
          <a href="#top" className="flex items-center gap-3" aria-label="实时爆料 首页">
            <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
              爆
            </span>
            <span className="flex flex-col">
              <span className="font-heading text-xl font-black leading-none tracking-wide">实时爆料</span>
              <span className="mt-1 font-label text-[10px] uppercase tracking-[0.25em] text-background-50/50">
                Real-time News Desk
              </span>
            </span>
          </a>

          <div className="flex items-center gap-4">
            <p className="hidden items-center gap-2 text-xs text-background-50/60 md:flex">
              <i className="ri-calendar-line text-background-50/40" aria-hidden="true" />
              今日热点 · 滚动更新中
            </p>
            <p className="hidden items-center gap-2 text-xs text-background-50/60 lg:flex">
              <i className="ri-time-line text-background-50/40" aria-hidden="true" />
              <span className="font-label text-sm tracking-widest text-accent-300">{clock}</span>
            </p>
            <a
              href="#contact"
              className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-400 md:inline-flex"
            >
              <i className="ri-send-plane-fill" aria-hidden="true" />
              我要投稿
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-background-50 transition-colors hover:bg-white/10 md:hidden"
              aria-label={open ? "关闭菜单" : "打开菜单"}
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-4-line text-xl"} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* 导航栏 */}
      <nav
        className="hidden border-b border-background-200 bg-background-100/95 backdrop-blur md:block"
        aria-label="主导航"
      >
        <div className="mx-auto flex max-w-[1440px] items-center gap-1 px-4 md:px-6">
          <a
            href="#top"
            className="flex items-center gap-2 border-r border-background-200 pr-4 font-label text-[11px] font-semibold uppercase tracking-widest text-foreground-500"
          >
            <i className="ri-home-4-line text-sm" aria-hidden="true" /> 首页
          </a>
          {NAV_LINKS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="relative px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
          <span className="ml-auto flex items-center gap-2 px-1 text-xs font-medium text-primary-600">
            <span className="h-2 w-2 animate-pulseDot rounded-full bg-primary-500" />
            在线 24 小时盯热点
          </span>
        </div>
      </nav>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-b border-background-200 bg-background-100 md:hidden">
          <div className="mx-auto flex max-w-[1440px] flex-col px-4 py-3">
            {NAV_LINKS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-200/60 py-3 text-sm font-medium text-foreground-800 last:border-0"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-3 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-send-plane-fill" aria-hidden="true" /> 我要投稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}